import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import * as TermsOfServiceDialogActions from './termsOfServiceDialogSlice';
import * as UserActions from '../Authorization/userSlice';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { agreeTermsOfService } from '../../shared/functions/userFunctions';
import logout from '../Authorization/Logout';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';
import { RouteInformation } from '../../shared/constants/RouteInformation';

export default function TermsOfServiceDialog(props) {
  const navigate = useNavigate();

  const { shouldNavigate } = props;
  const [isLoading, setIsLoading] = useState(false);

  const termsOfServiceDialog = useSelector((state) => state.termsOfServiceDialog);
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const onAgree = async () => {
    setIsLoading(true);
    try {
      await agreeTermsOfService({
        id: user.userInfo.id,
        docName: termsOfServiceDialog.docName,
        version: termsOfServiceDialog.version,
      });
      setIsLoading(false);
      dispatch(TermsOfServiceDialogActions.closeTermsOfServiceDialog());
      dispatch(UserActions.setUserHasAgreedAgreedTermsOfService(true));

      if (shouldNavigate) {
        navigate(RouteInformation.serviceLog.path, { replace: true });
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleClose = () => {
    logout(user.userInfo.username, () => {
      dispatch(TermsOfServiceDialogActions.closeTermsOfServiceDialog());
      dispatch(UserActions.userLogout());
    });
  };

  let dialogContent = <DialogContentText>Loading...</DialogContentText>;
  if (termsOfServiceDialog.htmlString) {
    dialogContent = (
      <DialogContentText dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsOfServiceDialog.htmlString) }} />
    );
  }

  return (
    <Dialog scroll="paper" open={termsOfServiceDialog.isOpen} data-cy="terms-of-service-dialog" sx={{ zIndex: 1500 }}>
      <DialogTitle>User Agreement</DialogTitle>
      <DialogContent dividers>{dialogContent}</DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <LoadingButton variant="contained" loading={isLoading} onClick={onAgree} data-cy="agree-button">
          Agree
        </LoadingButton>
        <Button variant="outlined" onClick={handleClose} data-cy="logout-button">
          Decline & Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
}
